<div class="flex flex-wrap mt-8 mb-6">

    @let user = (user$ | async);

    <div class="w-full flex flex-row justify-between mb-4">
        <app-btn-back routeTo=".."></app-btn-back>
    </div>

    <div class="mb-4 border-0 w-full">
        <h1 class="font-semibold text-2xl capitalize text-primary-500">
            {{ user?.uid == parent?.memberId ? 'My Children' : parent?.name }}
        </h1>
    </div>

    <div class="flex flex-col w-full">

        <list-utils-bar [searchDisabled]="true" (onRefresh)="onRefresh()"></list-utils-bar>

        @let loading = (loading$ | async) ?? false;
        @if (!loading) {
        <div class="grid grid-cols-1 gap-4">
            @for (item of children; track item.id) {
            <div class="bg-white shadow-lg rounded-lg w-full px-4 py-3 flex flex-row justify-between">
                <div [routerLink]="['students', item.memberId]" class="cursor-default">
                    <div class="flex items-start flex-row">
                        <div class="inline-block flex-none">
                            @if (item?.photoURL) {
                            <img [src]="item?.photoURL"
                                class="min-h-10 max-h-10 max-w-10 min-w-10 bg-white object-cover object-center rounded-full border-none" />
                            } @else {
                            <div
                                class="bg-primary-100 uppercase truncate text-primary-500 text-base flex justify-center items-center text-center h-10 w-10 rounded-full">
                                {{item?.name | initials}}
                            </div>
                            }
                        </div>
                        <div class="flex flex-col items-start col-span ml-3">
                            <div class="flex flex-row gap-2">
                                <span class="font-semibold truncate text-blueGray-600">{{item?.name}}</span>
                                <app-btn-member-status [status]="item?.status"
                                    [isDisabled]="true"></app-btn-member-status>
                            </div>
                            <span class="text-primary-200 truncate text-xs inline-flex">
                                {{item?.gradeName}}</span>

                        </div>
                    </div>
                </div>
                @if ((myRoles$ | async).management) {
                <div class="flex flex-row gap-2 whitespace-nowrap">
                    <app-btn-fab (click)="onDelinkChild(item)" icon="fa fa-link-slash"
                        textColor="text-red-500 disabled:text-gray-200" tooltip="Delink Child"></app-btn-fab>
                </div>
                }
            </div>
            } @empty {
            <div class="px-6 py-4 text-sm text-center font-semibold border-0 whitespace-nowrap">
                No Child Records Found
            </div>
            }
        </div>
        } @else {
        <loading-member></loading-member>
        }
    </div>
</div>